export type CropArea = {
  height: number;
  width: number;
  x: number;
  y: number;
};

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("Failed to load avatar image for cropping."));
    image.src = src;
  });
}

export async function cropAvatarImage(
  imageSrc: string,
  cropArea: CropArea,
  originalFileName: string,
): Promise<File> {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  if (!context) {
    throw new Error("Canvas is not available for avatar cropping.");
  }

  canvas.width = cropArea.width;
  canvas.height = cropArea.height;

  context.drawImage(
    image,
    cropArea.x,
    cropArea.y,
    cropArea.width,
    cropArea.height,
    0,
    0,
    cropArea.width,
    cropArea.height,
  );

  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob((nextBlob) => {
      if (!nextBlob) {
        reject(new Error("Failed to create cropped avatar image."));
        return;
      }
      resolve(nextBlob);
    }, "image/png");
  });

  const baseName = originalFileName.replace(/\.[^.]+$/, "") || "avatar";
  return new File([blob], baseName + "-cropped.png", { type: "image/png" });
}
